export default __webpack_public_path__ + "static/media/user.8f6c6dae.svg";